export default __webpack_public_path__ + "static/media/img_board_list.2b40ad83.png";